// ─── What: pin head geometry ──────────────────────────────────────────────────
//
// The head shape encodes the signal type, so the panel can be read without
// hovering every mark. Pure path strings.

export function pinTriangle(
    cx: number,
    cy: number,
    r: number,
    up: boolean
): string {
    return up
        ? `M${cx},${cy - r} L${cx - r * 0.87},${cy + r * 0.5} L${cx + r * 0.87},${cy + r * 0.5} Z`
        : `M${cx},${cy + r} L${cx - r * 0.87},${cy - r * 0.5} L${cx + r * 0.87},${cy - r * 0.5} Z`;
}

export function pinDiamond(cx: number, cy: number, r: number): string {
    return `M${cx},${cy - r} L${cx + r * 0.75},${cy} L${cx},${cy + r} L${cx - r * 0.75},${cy} Z`;
}

export function pinCirclePath(cx: number, cy: number, r: number): string {
    return `M${cx - r},${cy} a${r},${r} 0 1,0 ${r * 2},0 a${r},${r} 0 1,0 ${-r * 2},0`;
}

export function pinHeadPath(
    cx: number,
    cy: number,
    r: number,
    signalType: string,
    direction: string | null
): string {
    switch (signalType) {
        case 'probability_spike':
            return pinDiamond(cx, cy, r);
        case 'probability_change':
            return pinTriangle(cx, cy, r, direction !== 'bearish');
        case 'volume_anomaly':
            return pinCirclePath(cx, cy, r);
        case 'activity_surge':
            return pinDiamond(cx, cy, r);
        default:
            return pinCirclePath(cx, cy, r);
    }
}
